export default function applyMarkReceived(rows, idx, amount, date) {
  const amt = Number(amount || 0);
  if (!(idx >= 0) || !amt || amt < 0 || !date) return rows;
  return rows.map((r, i) => (i === idx ? { ...r, status: "Received", receivedAmount: amt, receivedDate: date } : r));
}